
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/editorSearch/views/SearchResultsList/SearchResultsList.scss.css.virtualfile';
        module.exports = {"container":"_container_whnqz_1"};